import * as amplitude from "@amplitude/analytics-browser";
import type { Analytics} from "@common/services/analytics";
import { makeAnalytics } from "@common/services/analytics";

const ssrAnalytics = {
  isTest: true,
  setUser: () => {},
  track: () => {},
  setIsTest: () => {},
} as Analytics;

export const analytics = typeof window === "undefined" ? ssrAnalytics : makeAnalytics({ amplitude });
